export function enshortenName(name) {
  while (name.length > 20) {
    let names = name.split(/\s+/)
    if (names.length > 1) {
      name = names.slice(0, -1).join(" ")
    } else {
      name = name.substring(0, 17) + "..."
    }
  }
  return name
}

export function maxNameAllowed(name) {
  while (name.length > 50) {
    let names = name.split(/\s+/)
    if (names.length > 1) {
      name = names.slice(0, -1).join(" ")
    } else {
      name = name.substring(0, 47) + "..."
    }
  }
  return name
}
